import reactContainerFactory from '@/components/react-container/reactContainerFactory';
import { lazy } from 'react';
import { RouteConfig } from 'vue-router';

const wes: RouteConfig = {
  path: '/wes',
  name: 'wes',
  meta: {
    title: 'WES',
    icon: 'Report Center',
  },
  redirect: '/wes/fulfillmentChain/fulfillment-chain-requirement',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      path: 'fulfillmentChain',
      name: 'wes.fulfillmentchainrequirementreport',
      meta: {
        title: 'Fulfillment Chain',
      },
      redirect: '/wes/fulfillmentChain/fulfillment-chain-requirement',
      component: () => import('../../views/layout/subPage.vue'),
      children: [
        {
          path: 'fulfillment-chain-requirement',
          name: 'PC.WES.FulfillmentChainRequirementReport',
          meta: {
            title: 'Fulfillment Chain Requirement',
            menuHide: true,
          },
          component: () => import('@/views/wes/fulfillment-chain/index.vue'),
        },
        {
          path: 'logic-area-requirement',
          name: 'wes.logicAreaRequirement',
          meta: {
            menuHide: true,
            title: 'Logic Area Requirement',
          },
          component: () => import('@/views/wes/fulfillment-chain/index.vue'),
        },
        {
          path: 'warehouse-requirement',
          name: 'wes.warehouseRequirement',
          meta: {
            menuHide: true,
            title: 'Warehouse Requirement',
          },
          component: () => import('@/views/wes/fulfillment-chain/index.vue'),
        },
        {
          path: 'fulfillment-chain-daily-sales-rule',
          name: 'wes.fulfillmentChainDailySalesRule',
          meta: {
            menuHide: true,
            title: 'Fulfillment Chain Daily Sales Rule',
          },
          component: () => import('@/views/wes/fulfillment-chain/index.vue'),
        },
        {
          path: 'fulfillment-chain-turnover-days-rule',
          name: 'wes.fulfillmentChainTurnoverDaysRule',
          meta: {
            menuHide: true,
            title: 'Fulfillment Chain Turnover Days Rule',
          },
          component: () => import('@/views/wes/fulfillment-chain/index.vue'),
        },
        {
          path: 'fulfillment-chain-turnover-days-rule/create',
          name: 'wes.fulfillmentChainTurnoverDaysRule.create',
          meta: {
            title: 'Create Rule',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'wes.fulfillmentChainTurnoverDaysRule.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/fulfillment-chain-turnover-days-rule/create'
                  )
              ),
          },
        },
        {
          path: 'fulfillment-chain-turnover-days-rule/edit',
          name: 'wes.fulfillmentChainTurnoverDaysRule.edit',
          meta: {
            title: 'Edit Rule',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'wes.fulfillmentChainTurnoverDaysRule.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/fulfillment-chain-turnover-days-rule/update'
                  )
              ),
          },
        },
        {
          path: 'fulfillment-chain-turnover-days-rule/detail',
          name: 'wes.fulfillmentChainTurnoverDaysRule.detail',
          meta: {
            title: 'Rule Detail',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'wes.fulfillmentChainTurnoverDaysRule.detail',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/fulfillment-chain-turnover-days-rule/detail'
                  )
              ),
          },
        },
        {
          path: 'inventory-route',
          name: 'wes.inventoryRoute',
          meta: {
            menuHide: true,
            title: 'Inventory Route',
          },
          component: () => import('@/views/layout/subPage.vue'),
          redirect: '/wes/fulfillmentChain/inventory-route/inbound',
        },
        {
          path: 'inventory-route/inbound',
          name: 'wes.inventoryRoute.inbound',
          meta: {
            menuHide: true,
            title: 'Inventory Route',
          },
          component: () => import('@/views/wes/fulfillment-chain/index.vue'),
        },
        {
          path: 'inventory-route/inbound/create',
          name: 'PC.WES.InventoryRoute.Inbound.Create',
          meta: {
            title: 'Create Route',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'PC.WES.InventoryRoute.Inbound.Create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import('@/react-app/pages/rule-center/inventory-route/create')
              ),
          },
        },
        {
          path: 'inventory-route/inbound/edit',
          name: 'PC.WES.InventoryRoute.Inbound.Edit',
          meta: {
            title: 'Edit Route',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'PC.WES.InventoryRoute.Inbound.Edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import('@/react-app/pages/rule-center/inventory-route/create')
              ),
          },
        },
        {
          path: 'inventory-route/replenishment',
          name: 'wes.inventoryRoute.replenishment',
          meta: {
            menuHide: true,
            title: 'Inventory Route',
          },
          component: () => import('@/views/wes/fulfillment-chain/index.vue'),
        },
        {
          path: 'inventory-route/reverse',
          name: 'wes.inventoryRoute.reverse',
          meta: {
            menuHide: true,
            title: 'Inventory Route',
          },
          component: () => import('@/views/wes/fulfillment-chain/index.vue'),
        },
        {
          path: 'fulfillmentChain',
          // name: 'wes.fulfillmentChainConfig',
          meta: {
            menuHide: true,
            title: 'Fulfillment Chain Config',
          },
          component: () => import('@/views/layout/subPage.vue'),
          redirect: '/wes/fulfillmentChain/fulfillment-chain-config',
        },
        {
          path: 'fulfillmentChain/fulfillment-chain-config',
          name: 'wes.fulfillmentChainConfig',
          meta: {
            menuHide: true,
            title: 'Fulfillment Chain Config',
          },
          component: () => import('@/views/wes/fulfillment-chain/index.vue'),
        },
        {
          path: 'fulfillmentChain/fulfillment-chain-config/create',
          name: 'PC.WES.FulfillmentChain.Create',
          meta: {
            title: 'Create',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'wes.fulfillmentchain',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/fullfillment-chain-config/fullfillment-chain-edit'
                  )
              ),
          },
        },
        {
          path: 'fulfillmentChain/fulfillment-chain-config/edit/:id',
          name: 'PC.WES.FulfillmentChain.Edit',
          meta: {
            title: 'Edit',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'wes.fulfillmentchain',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/fullfillment-chain-config/fullfillment-chain-edit'
                  )
              ),
          },
        },
        {
          path: 'fulfillmentChain/fulfillment-chain-config/view/:id',
          name: 'PC.WES.FulfillmentChain.View',
          meta: {
            title: 'Detail',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'wes.fulfillmentchain',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/fullfillment-chain-config/fullfillment-chain-edit'
                  )
              ),
          },
        },
        {
          path: 'fulfillmentChain/fulfillment-chain-scenario',
          name: 'wes.fulfillmentChainConfig.fulfillmentChainScenario',
          meta: {
            menuHide: true,
            title: 'Fulfillment Chain Scenario',
          },
          component: () => import('@/views/wes/fulfillment-chain/index.vue'),
        },
        {
          path: 'fulfillmentChain/fulfillment-chain-scenario/create',
          name: 'PC.WES.FulfillmentScenario.Create',
          meta: {
            title: 'Create',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'wes.fulfillmentchain.fulfillmentChainScenario.create',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/fullfillment-chain-scenario/edit'
                  )
              ),
          },
        },
        {
          path: 'fulfillmentChain/fulfillment-chain-scenario/edit/:id',
          name: 'PC.WES.FulfillmentScenario.Edit',
          meta: {
            title: 'Edit',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'wes.fulfillmentchain.fulfillmentChainScenario.edit',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/fullfillment-chain-scenario/edit'
                  )
              ),
          },
        },
        {
          path: 'fulfillmentChain/fulfillment-chain-scenario/view/:id',
          name: 'PC.WES.FulfillmentScenario.View',
          meta: {
            title: 'Detail',
            menuHide: true,
          },
          component: reactContainerFactory({
            name: 'wes.fulfillmentchain.fulfillmentChainScenario.view',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/rule-center/fullfillment-chain-scenario/edit'
                  )
              ),
          },
        },
      ],
    },
  ],
};
export default wes;
